<template>
  <div class="encuestas">
    <b-navbar type="dark" variant="utb-blue" fixed="top">
      <b-navbar-brand href="#">
        <img src="images/logo_utb_blanco.png" alt="Logo" class="d-inline-block align-top" />
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-text>{{ $oauth.data.sub }} {{ $oauth.data.name ? $oauth.data.name : ''}}</b-nav-text>
        <b-nav-item @click="logout">Logout</b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <b-container class="mt-3 clear-navbar">
      <h2 class="app-name text-center text-primary">Actualiza UTB</h2>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)" @reset="onReset" novalidate>
          <div role="tablist">
            <!--Protección de datos-->
            <b-card no-body v-if="visibles.indexOf('proteccionDatos') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('proteccionDatos'))" block :disabled="!actives.includes('proteccionDatos')">Consentimiento de tratamiento de datos</b-button>
              </b-card-header>
              <b-collapse id="proteccion-datos" accordion="accordion" role="tabpanel" :visible="visible === 'proteccionDatos'">
                <b-card-body v-if="visible === 'proteccionDatos'">
                  <p>En la UTB queremos acompañarte a desarrollar todo tu potencial académico y profesional. Por eso, queremos conocerte más. El siguiente cuestionario no tardará más de 15 minutos, y aborda aspectos familiares, económicos, académicos y de salud.</p>
                  <p>Tus respuestas serán fundamentales para implementar estrategias enfocadas en mejorar tu experiencia en la Universidad, por eso agradecemos tu sinceridad.</p>
                  <p>La información aquí consignada es de carácter confidencial.</p>
                  <validation-provider name="Políticas de Tratamiento y Protección de datos" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-checkbox-group id="select-politica-datos" v-model="caracterizacion.politicaDatos" :state="getValidationState(validationContext)" stacked>
                      <b-form-checkbox value="SI">
                        He leído y acepto las
                        <a href="https://www.utb.edu.co/sites/web.unitecnologica.edu.co/files/descargas/res_ndeg1_de_2015_-_establece_las_politicas_y_procedimientos_en_materia_de_proteccion_de_datos_personales_0.pdf" target="_blank">políticas de tratamiento y protección de datos</a> relacionada al presente formulario
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-card-body>
                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos personales-->
            <b-card no-body v-if="visibles.indexOf('datosPersonales') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosPersonales'))" block :disabled="!actives.includes('datosPersonales')">Datos personales</b-button>
              </b-card-header>
              <b-collapse id="datos-personales" accordion="accordion" role="tabpanel" :visible="visible === 'datosPersonales'" @show.once="loadDatosPersonales">
                <b-card-body v-if="visible === 'datosPersonales'">
                  <validation-provider name="Tipo de identificación" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Tipo de identificación:" label-for="select-tipo-identificacion">
                      <b-form-select id="select-tipo-identificacion" v-model="caracterizacion.tipoIdentificacion" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in tiposIdentificacion" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Número de identificación" :rules="{ required: true, alpha_num: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Número de identificación:" label-for="input-numero-identificacion">
                      <b-form-input id="input-numero-identificacion" v-model="caracterizacion.identificacion" placeholder="Ingresa tu número de identificación" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  <!--
                  <b-form-group label-cols-md="4" label="Foto:" label-for="file-foto">
                    <b-form-file id="file-foto" v-model="foto" placeholder="Selecciona una foto" drop-placeholder="Arrastra una foto aquí" accept="image/jpeg, image/png, image/gif" @input="subirFoto"></b-form-file>
                  </b-form-group>
                  -->

                  <validation-provider name="¿Con cuál género te identificas?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Con cuál género te identificas?" label-for="select-genero">
                      <b-form-select id="select-genero" v-model="caracterizacion.genero" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Seleccione una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in generos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Estado civil" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Estado civil:" label-for="select-estado-civil">
                      <b-form-select id="select-estado-civil" v-model="caracterizacion.estadoCivil" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in estadosCiviles" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Te identificas con alguna etnia?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Te identificas con alguna etnia?" label-for="select-etnia">
                      <b-form-select id="select-etnia" v-model="caracterizacion.etnia" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in etnias" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Indica qué tipo de condición presentas" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Indica qué tipo de condición presentas:" label-for="select-discapacidad">
                      <b-form-radio-group id="select-discapacidad" v-model="caracterizacion.discapacidad" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in discapacidades" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Indica si eres un estudiante con talentos excepcionales" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Indica si eres un estudiante con talentos excepcionales:" label-for="select-talentos">
                      <b-form-radio-group id="select-talentos" v-model="caracterizacion.talentos" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-text>Responda sí solo en caso de contar con el diagnóstico de un profesional de la salud.</b-form-text>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Has sido identificado por alguna institución gubernamental como población víctima del conflicto armado?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Has sido identificado por alguna institución gubernamental como población víctima del conflicto armado?" label-for="select-victima">
                      <b-form-radio-group id="select-victima" v-model="caracterizacion.victima" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <!-- <b-form-text>¿Has sido identificado por alguna institución gubernamental como población víctima del conflicto armado?</b-form-text> -->
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Haces parte del grupo de personas desmovilizada en proceso de reintegración?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Haces parte del grupo de personas desmovilizada en proceso de reintegración?" label-for="select-desmovilizado">
                      <b-form-radio-group id="select-desmovilizado" v-model="caracterizacion.desmovilizado" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <!-- <b-form-text>¿Haces parte del grupo de personas desmovilizada y/o en proceso de reintegración?</b-form-text> -->
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>
                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos de contacto-->
            <b-card no-body v-if="visibles.indexOf('datosDeContacto') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosDeContacto'))" block :disabled="!actives.includes('datosDeContacto')">Datos de contacto</b-button>
              </b-card-header>
              <b-collapse id="datos-de-contacto" accordion="accordion" role="tabpanel" :visible="visible === 'datosDeContacto'" @show.once="loadDatosDeContacto">
                <b-card-body v-if="visible === 'datosDeContacto'">
                  <validation-provider name="Correo electrónico personal" :rules="{ required: true, email: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Correo electrónico personal:" label-for="input-email">
                      <b-form-input id="input-email" v-model="caracterizacion.email" placeholder="Ingresa tu dirección de email" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Número de celular" :rules="{ required: true, integer: true, min: 10, max: 10 }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Número de celular:" label-for="input-celular">
                      <b-form-input id="input-celular" v-model="caracterizacion.celular" placeholder="Ingresa tu no. de celular" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <p class="font-italic">La residencia habitual se entiende como el lugar en el que vives normalmente, si eres de un lugar fuera de Cartagena y te has mudado temporalmente por motivos de estudio, entonces sería tu residencia de donde provienes</p>

                  <validation-provider name="País de residencia habitual" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="País de residencia habitual:" label-for="select-pais-residencia">
                      <b-form-select id="select-pais-residencia" v-model="caracterizacion.residencia.pais" :state="getValidationState(validationContext)" @change="onPaisChange">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in paises" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Departamento/Estado de residencia habitual" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Departamento/Estado de residencia habitual:" label-for="select-estado-residencia">
                      <b-form-select id="select-estado-residencia" v-model="caracterizacion.residencia.estado" :state="getValidationState(validationContext)" @change="onDepartamentoChange" v-if="estados.length > 0">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in estados" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-input id="select-estado-residencia" v-model="caracterizacion.residencia.estado" :state="getValidationState(validationContext)" v-else></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Municipio de residencia habitual" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Municipio de residencia habitual:" label-for="select-ciudad-residencia">
                      <b-form-select id="select-ciudad-residencia" v-model="caracterizacion.residencia.ciudad" :state="getValidationState(validationContext)" @change="onCiudadChange" v-if="ciudades.length > 0">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in ciudades" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-input id="select-ciudad-residencia" v-model="caracterizacion.residencia.ciudad" :state="getValidationState(validationContext)" v-else></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Barrio de residencia habitual" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Barrio de residencia habitual:" label-for="input-barrio-residencia">
                      <b-form-select id="select-barrio-residencia" v-model="caracterizacion.residencia.barrio" :state="getValidationState(validationContext)" v-if="barrios.length > 0">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in barrios" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-input id="input-ciudad-residencia" v-model="caracterizacion.residencia.barrio" :state="getValidationState(validationContext)" v-else></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Dirección de residencia habitual" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Dirección de residencia habitual:" label-for="input-direccion-residencia">
                      <!--
                      <b-form-input id="input-direccion-residencia" v-model="caracterizacion.residencia.direccion" placeholder="Ingresa la dirección donde resides" :state="getValidationState(validationContext)"></b-form-input>
                      -->
                      <street-address v-model="caracterizacion.residencia.direccion" :state="getValidationState(validationContext)"></street-address>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Localizar en el mapa" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group>
                      <p class="font-italic">Por favor confirma que tu ubicación geográfica en el mapa corresponde a tu ubicación real, si consideras que no es correcto puedes ubicar el punto manualmente, esta información es muy importante para nosotros</p>

                      <div class="float-left d-inline">
                        <b-button variant="link" @click.prevent="geoLocalizar" title="Haz clic aqui para intentar localizar tu dirección, o búscala manualmente en el mapa">Clic aquí para ubicar la dirección ingresada en el mapa</b-button>
                      </div>
                      <div class="float-right d-inline">
                        <b-button variant="primary" @click.prevent="$refs.map.geoLocalizar()">
                          <b-icon icon="map"></b-icon>Ubica tu posición actual en el mapa
                        </b-button>
                      </div>
                      <g-map ref="map" :center="map.center" :zoom="map.zoom" @change="onMapChange" style="width: 100%; height:320px"></g-map>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      <input type="hidden" v-model="caracterizacion.residencia.gps" />
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Producto de las actividades de tu semestre académico actual has tenido que desplazarte y vivir en un lugar diferente al de tu residencia habitual?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Producto de las actividades de tu semestre académico actual has tenido que desplazarte y vivir en un lugar diferente al de tu residencia habitual?" label-for="select-direccion-previa">
                      <b-form-radio-group id="select-direccion-previa" v-model="caracterizacion.tieneResidenciaTemporal" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <!-- <b-form-text>¿Coincide tu dirección de residencia actual con la dirección previa al confinamiento?</b-form-text> -->
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <template v-if="caracterizacion.tieneResidenciaTemporal === 'SI'">
                    <validation-provider name="País de residencia temporal" :rules="{ required: true }" v-slot="validationContext">
                      <b-form-group label-cols-md="4" label="País de residencia temporal:" label-for="select-pais-residencia-anterior">
                        <b-form-select id="select-pais-residencia-anterior" v-model="caracterizacion.residenciaTemporal.pais" :state="getValidationState(validationContext)" @change="onPaisAnteriorChange">
                          <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                          <b-form-select-option v-for="entry in paises" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                        </b-form-select>
                        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider name="Departamento/Estado de residencia temporal" :rules="{ required: true }" v-slot="validationContext">
                      <b-form-group label-cols-md="4" label="Departamento/Estado de residencia temporal:" label-for="select-estado-residencia-anterior">
                        <b-form-select id="select-estado-residencia-anterior" v-model="caracterizacion.residenciaTemporal.estado" :state="getValidationState(validationContext)" @change="onDepartamentoAnteriorChange" v-if="estadosTemporales.length > 0">
                          <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                          <b-form-select-option v-for="entry in estadosTemporales" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                        </b-form-select>
                        <b-form-input id="select-estado-residencia-anterior" v-model="caracterizacion.residenciaTemporal.estado" :state="getValidationState(validationContext)" v-else></b-form-input>
                        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider name="Municipio de residencia temporal" :rules="{ required: true }" v-slot="validationContext">
                      <b-form-group label-cols-md="4" label="Municipio de residencia temporal:" label-for="select-ciudad-residencia-antrior">
                        <b-form-select id="select-ciudad-residencia-anterior" v-model="caracterizacion.residenciaTemporal.ciudad" :state="getValidationState(validationContext)" @change="onCiudadAnteriorChange" v-if="ciudadesTemporales.length > 0">
                          <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                          <b-form-select-option v-for="entry in ciudadesTemporales" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                        </b-form-select>
                        <b-form-input id="select-ciudad-residencia-anterior" v-model="caracterizacion.residenciaTemporal.ciudad" :state="getValidationState(validationContext)" v-else></b-form-input>
                        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider name="Barrio de residencia temporal" :rules="{ required: true }" v-slot="validationContext">
                      <b-form-group label-cols-md="4" label="Barrio de residencia temporal:" label-for="input-barrio-residencia-anterior">
                        <b-form-select id="select-barrio-residencia-anterior" v-model="caracterizacion.residenciaTemporal.barrio" :state="getValidationState(validationContext)" v-if="barriosTemporales.length > 0">
                          <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                          <b-form-select-option v-for="entry in barriosTemporales" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                        </b-form-select>
                        <b-form-input id="input-ciudad-residencia-anterior" v-model="caracterizacion.residenciaTemporal.barrio" :state="getValidationState(validationContext)" v-else></b-form-input>
                        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider name="Dirección de residencia temporal" :rules="{ required: true }" v-slot="validationContext">
                      <b-form-group label-cols-md="4" label="Dirección de residencia temporal:" label-for="input-direccion-residencia-anterior">
                        <!--
                      <b-form-input id="input-direccion-residencia" v-model="caracterizacion.residenciaTemporal.direccion" placeholder="Ingresa la dirección donde resides" :state="getValidationState(validationContext)"></b-form-input>
                        -->
                        <street-address v-model="caracterizacion.residenciaTemporal.direccion" :state="getValidationState(validationContext)"></street-address>
                        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider name="Localizar en el mapa" :rules="{ required: true }" v-slot="validationContext">
                      <b-form-group>
                        <p class="font-italic">Por favor confirma que tu ubicación geográfica en el mapa corresponde a tu ubicación real, si consideras que no es correcto puedes ubicar el punto manualmente, esta información es muy importante para nosotros</p>
                        <div class="float-left d-inline">
                          <b-button variant="link" @click.prevent="geoLocalizarTemporal" title="Haz clic aqui para intentar localizar tu dirección, o búscala manualmente en el mapa">Clic aquí para ubicar la dirección ingresada en el mapa</b-button>
                        </div>
                        <div class="float-right d-inline">
                          <b-button variant="primary" @click.prevent="$refs.mapTemporal.geoLocalizar()">
                            <b-icon icon="map"></b-icon>Ubica tu posición actual en el mapa
                          </b-button>
                        </div>
                        <g-map ref="mapTemporal" :center="mapTemporal.center" :zoom="mapTemporal.zoom" @change="onMapAnteriorChange" style="width: 100%; height:320px"></g-map>
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        <input type="hidden" v-model="caracterizacion.residenciaTemporal.gps" />
                      </b-form-group>
                    </validation-provider>
                  </template>
                </b-card-body>
                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos familiares-->
            <b-card no-body v-if="visibles.indexOf('datosFamiliares') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosFamiliares'))" block :disabled="!actives.includes('datosFamiliares')">Datos familiares</b-button>
              </b-card-header>
              <b-collapse id="h-datos-datos-familiares" accordion="accordion" role="tabpanel" :visible="visible === 'datosFamiliares'" @show.once="loadDatosFamiliares">
                <b-card-body v-if="visible === 'datosFamiliares'">
                  <validation-provider name="¿Cuántos hermanos(as) tienes?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuántos hermanos(as) tienes?" label-for="h-select-numero-de-hermanos">
                      <b-form-radio-group id="h-select-numero-de-hermanos" v-model="caracterizacion.numeroDeHermanos" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in numeroPersonas" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es la posición que ocupas entre tus hermanos(as)?" :rules="{ required: true }" v-slot="validationContext" v-if="tieneHermanos">
                    <b-form-group label-cols-md="4" label="¿Cuál es la posición que ocupas entre tus hermanos(as)?" label-for="h-select-posicion-entre-hermanos">
                      <b-form-radio-group id="h-select-posicion-entre-hermanos" v-model="caracterizacion.posicionEntreHermanos" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in posicionesEntreHermanos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="De tus hermanos(as), ¿cuántos tienen estudios superiores terminados o en curso?" :rules="{ required: true }" v-slot="validationContext" v-if="tieneHermanos">
                    <b-form-group label-cols-md="4" label="De tus hermanos(as), ¿cuántos tienen estudios superiores terminados o en curso?" label-for="h-select-hermanos-con-estudios">
                      <b-form-radio-group id="h-select-hermanos-con-estudios" v-model="caracterizacion.hermanosConEstudios" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in numeroPersonas" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuántos hijos tienes?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuántos hijos tienes?" label-for="select-numero-hijos">
                      <b-form-radio-group id="h-select-numero-hijos" v-model="caracterizacion.numeroDeHijos" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in numeroPersonas" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Qué edad(es) tienen tus hijos?" :rules="{ required: true }" v-slot="validationContext" v-if="tieneHijos">
                    <b-form-group label-cols-md="4" label="¿Qué edad(es) tienen tus hijos?" label-for="h-select-edad-de-hijos">
                      <b-form-checkbox-group id="h-select-edad-de-hijos" v-model="caracterizacion.edadDeHijos" :state="getValidationState(validationContext)" stacked>
                        <b-form-checkbox v-for="entry in edadesDeHijos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>

                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos socioeconomicos-->
            <b-card no-body v-if="visibles.indexOf('datosSocioeconomicos') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosSocioeconomicos'))" block :disabled="!actives.includes('datosSocioeconomicos')">Datos socioeconómicos</b-button>
              </b-card-header>
              <b-collapse id="datos-socioeconomicos" accordion="accordion" role="tabpanel" :visible="visible === 'datosSocioeconomicos'" @show.once="loadDatosSocioeconomicos">
                <b-card-body v-if="visible === 'datosSocioeconomicos'">
                  <validation-provider name="Situación laboral" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Situación laboral:" label-for="select-situacion-laboral">
                      <b-form-select id="select-situacion-laboral" v-model="caracterizacion.situacionLaboral" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in situacionesLaborales" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Dedicación laboral" :rules="{ required: true }" v-slot="validationContext" v-if="empleadoIndependiente">
                    <b-form-group label-cols-md="4" label="Dedicación laboral:" label-for="select-dedicacion-laboral">
                      <b-form-select id="select-dedicacion-laboral" v-model="caracterizacion.dedicacionLaboral" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in dedicacionesLaborales" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Recibes pago o salario por tu trabajo?" :rules="{ required: true }" v-slot="validationContext" v-if="empleadoIndependiente">
                    <b-form-group label-cols-md="4" label="¿Recibes pago o salario por tu trabajo?" label-for="select-salario">
                      <b-form-radio-group id="select-salario" v-model="caracterizacion.salario" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es el estado civil actual de tus padres?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuál es el estado civil actual de tus padres?" label-for="select-estado-civil-padres">
                      <b-form-radio-group id="select-estado-civil-padres" v-model="caracterizacion.estadoCivilPadres" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in estadosCivilesPadres" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Situación laboral de tu padre" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Situación laboral de tu padre:" label-for="select-situacion-laboral-padre">
                      <b-form-select id="select-situacion-laboral-padre" v-model="caracterizacion.situacionLaboralPadre" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in situacionesLaboralesMasculinas" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es el nivel educativo más alto alcanzado por tu padre?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuál es el nivel educativo más alto alcanzado por tu padre?" label-for="select-nivel-academico-padre">
                      <b-form-radio-group id="select-nivel-academico-padre" v-model="caracterizacion.nivelAcademicoPadre" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in nivelesAcademicos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Situación laboral de tu madre" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Situación laboral de tu madre:" label-for="select-situacion-laboral-madre">
                      <b-form-select id="select-situacion-laboral-madre" v-model="caracterizacion.situacionLaboralMadre" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in situacionesLaboralesFemeninas" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es el nivel educativo más alto alcanzado por tu madre?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuál es el nivel educativo más alto alcanzado por tu madre?" label-for="select-nivel-academico-madre">
                      <b-form-radio-group id="select-nivel-academico-madre" v-model="caracterizacion.nivelAcademicoMadre" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in nivelesAcademicos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Situación laboral de tu cónyuge" :rules="{ required: true }" v-slot="validationContext" v-if="casadoOUnionLibre">
                    <b-form-group label-cols-md="4" label="Situación laboral de tu cónyuge:" label-for="select-situacion-laboral-conyuge">
                      <b-form-select id="select-situacion-laboral-conyuge" v-model="caracterizacion.situacionLaboralConyuge" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in situacionesLaborales" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es el nivel educativo más alto alcanzado por tu cónyuge?" :rules="{ required: true }" v-slot="validationContext" v-if="casadoOUnionLibre">
                    <b-form-group label-cols-md="4" label="¿Cuál es el nivel educativo más alto alcanzado por tu cónyuge?" label-for="select-nivel-academico-conyuge">
                      <b-form-radio-group id="select-nivel-academico-conyuge" v-model="caracterizacion.nivelAcademicoConyuge" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in nivelesAcademicos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuántas personas conviven contigo actualmente?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuántas personas conviven contigo actualmente?" label-for="select-numero-de-personas-conviven">
                      <b-form-radio-group id="select-numero-de-personas-conviven" v-model="caracterizacion.numeroDePersonasConviven" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in numeroPersonas" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Con qué personas vives actualmente?" :rules="{ required: true }" v-slot="validationContext" v-if="convive">
                    <b-form-group label-cols-md="4" label="¿Con qué personas vives actualmente?" label-for="select-personas-conviven">
                      <b-form-checkbox-group id="select-personas-conviven" v-model="caracterizacion.personasConvive" :state="getValidationState(validationContext)" stacked>
                        <b-form-checkbox v-for="entry in personasConvive" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuántas personas tienes a tu cargo?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuántas personas tienes a tu cargo?" label-for="select-numero-de-personas-a-cargo">
                      <b-form-radio-group id="select-numero-de-personas-a-cargo" v-model="caracterizacion.numeroDePersonasACargo" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in numeroPersonas" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-text>Personas que dependen económicamente de ti o requieren cuidado físico</b-form-text>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Convives con personas menores de 5 años o mayores de 65 años?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Convives con personas menores de 5 años o mayores de 65 años?" label-for="select-edades-convive">
                      <b-form-radio-group id="select-edades-convive" v-model="caracterizacion.edadesPersonasConvive" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in edadesPersonasConvive" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿En cuál de los siguientes rangos se encuentra el ingreso mensual de tu familia?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿En cuál de los siguientes rangos se encuentra el ingreso mensual de tu familia?" label-for="select-ingresos-hogar">
                      <b-form-radio-group id="select-ingresos-hogar" v-model="caracterizacion.ingresoHogar" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in ingresosHogar" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿En qué tipo de vivienda resides?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿En qué tipo de vivienda resides?" label-for="select-vivienda">
                      <b-form-radio-group id="select-vivienda" v-model="caracterizacion.vivienda" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in viviendas" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es el estrato socioeconómico de tu residencia actual?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuál es el estrato socioeconómico de tu residencia actual?" label-for="select-estratos">
                      <b-form-radio-group id="select-estratos" v-model="caracterizacion.estrato" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in estratos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-text>Se sugiere tener en cuenta el estrato reportado en la factura del gas domiciliario</b-form-text>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es el nivel del SISBEN en el que está clasificada tu familia?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuál es el nivel del SISBEN en el que está clasificada tu familia?" label-for="h-select-nivel-sisben">
                      <b-form-radio-group id="h-select-nivel-sisben" v-model="caracterizacion.sisben" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in nivelesSisben" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>
                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos de acceso tecnológico-->
            <b-card no-body v-if="visibles.indexOf('datosAccesoTecnologico') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosAccesoTecnologico'))" block :disabled="!actives.includes('datosAccesoTecnologico')">Datos de acceso tecnológico</b-button>
              </b-card-header>
              <b-collapse id="h-datos-acceso-tecnologico" accordion="accordion" role="tabpanel" :visible="visible === 'datosAccesoTecnologico'" @show.once="loadDatosAccesoTecnologico">
                <b-card-body v-if="visible === 'datosAccesoTecnologico'">
                  <validation-provider name="¿Por cuál opción accedes o vas a acceder a internet para el desarrollo de tus clases, tareas y trabajos?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Por cuál opción accedes o vas a acceder a internet para el desarrollo de tus clases, tareas y trabajos?" label-for="h-select-acceso-internet">
                      <b-form-radio-group id="h-select-acceso-internet" v-model="caracterizacion.accesoInternet" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in accesoInternet" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es tu situación con respecto al uso de computador para el desarrollo de tus clases, tareas y trabajos?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuál es tu situación con respecto al uso de computador para el desarrollo de tus clases, tareas y trabajos?" label-for="h-select-disponibilidad-pc">
                      <b-form-radio-group id="h-select-disponibilidad-pc" v-model="caracterizacion.accesoComputador" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in accesoComputador" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuenta con un celular que permita compartir internet?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuenta con un celular que permita compartir internet?" label-for="h-select-disponibilidad-celular">
                      <b-form-radio-group id="h-select-disponibilidad-celular" v-model="caracterizacion.disponibilidadCelularCompartir" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>

                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos de movilidad-->
            <b-card no-body v-if="visibles.indexOf('datosDeMovilidad') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosDeMovilidad'))" block :disabled="!actives.includes('datosDeMovilidad')">Datos de movilidad</b-button>
              </b-card-header>
              <b-collapse id="h-datos-de-movilidad" accordion="accordion" role="tabpanel" :visible="visible === 'datosDeMovilidad'">
                <b-card-body v-if="visible === 'datosDeMovilidad'">
                  <p>En esta sección encontrarás algunas preguntas relacionadas a tu movilidad en los últimos meses , ya que en el marco de la contingencia de la pandemia, ésta es información relevante para la Universidad.</p>
                  <validation-provider name="¿Qué medio de transporte acostumbras usar?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Qué medio de transporte acostumbras usar?" label-for="h-select-medio-transporte">
                      <b-form-select id="h-select-medio-transporte" v-model="caracterizacion.medioTransporte" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Seleccione una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in mediosTransportes" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Has estado en lugares diferentes a tu hogar en los últimos 10 días?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Has estado en lugares diferentes a tu hogar en los últimos 10 días?" label-for="h-select-lugares-direfentes">
                      <b-form-radio-group id="h-select-lugares-direfentes" v-model="caracterizacion.lugaresDiferentes" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Has realizado un viaje internacional en los últimos 30 días?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Has realizado un viaje internacional en los últimos 30 días?" label-for="h-select-viaje-internacional">
                      <b-form-radio-group id="h-select-viaje-internacional" v-model="caracterizacion.viajeInternacional" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Has realizado un viaje nacional en los últimos 30 días?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Has realizado un viaje nacional en los últimos 30 días?" label-for="h-select-viaje-nacional">
                      <b-form-radio-group id="h-select-viaje-nacional" v-model="caracterizacion.viajeNacional" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Has estado en contacto estrecho con personas que han realizado viajes al exterior en los últimos 30 días?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Has estado en contacto estrecho con personas que han realizado viajes al exterior en los últimos 30 días?" label-for="h-select-contacto-migrantes">
                      <b-form-radio-group id="h-select-contacto-migrantes" v-model="caracterizacion.contactoMigrantes" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>

                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos medicos-->
            <b-card no-body v-if="visibles.indexOf('datosMedicos') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosMedicos'))" block :disabled="!actives.includes('datosMedicos')">Datos médicos</b-button>
              </b-card-header>
              <b-collapse id="h-datos-medicos" accordion="accordion" role="tabpanel" :visible="visible === 'datosMedicos'" @show.once="loadDatosMedicos">
                <b-card-body v-if="visible === 'datosMedicos'">
                  <p>En esta sección encontrarás preguntas relacionadas a factores de riesgo para Covid-19, ya que en el marco de la contingencia de la pandemia, ésta es información relevante para la Universidad.</p>
                  <validation-provider name="¿A qué régimen de salud perteneces?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿A qué régimen de salud perteneces?" label-for="h-select-regimen-salud">
                      <b-form-select id="h-select-regimen-salud" v-model="caracterizacion.regimenSalud" :state="getValidationState(validationContext)" @change="onRegimenSaludChange">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in regimenesSalud" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Selecciona tu entidad promotora de salud" :rules="{ required: true }" v-if="perteneceARegimen && eps.length > 0" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Selecciona tu entidad promotora de salud:" label-for="h-select-eps">
                      <b-form-select id="h-select-eps" v-model="caracterizacion.eps" :state="getValidationState(validationContext)">
                        <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
                        <b-form-select-option v-for="entry in eps" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-select-option>
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!--
                  <validation-provider name="Fecha de vigencia afiliación Régimen de Salud" :rules="{ required: true }" v-if="perteneceARegimen" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Fecha de vigencia afiliación Régimen de Salud:" label-for="h-fecha-vigencia-afiliacion">
                      <b-form-datepicker id="h-fecha-vigencia-afiliacion" v-model="caracterizacion.fechaVigenciaAfiliacion" :state="getValidationState(validationContext)" placeholder="Selecciona la fecha de vigencia de tu afiliación"></b-form-datepicker>
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Certificado de Afiliación Régimen de Salud" :rules="{ required: true }" v-if="perteneceARegimen" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Certificado de Afiliación Régimen de Salud:" label-for="h-file-certificado-afiliacion">
                      <b-form-file id="h-file-certificado-afiliacion" v-model="certificadoAfiliacion" placeholder="Selecciona un documento" drop-placeholder="Arrastra un documento aquí" accept="application/pdf" @input="subirCertificado" :state="getValidationState(validationContext)"></b-form-file>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  -->

                  <validation-provider name="Peso" :rules="{ required: true, min_value: 1, max_value: 200 }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Peso:" label-for="h-input-peso">
                      <b-form-input type="number" step="0.1" id="h-input-peso" v-model="caracterizacion.peso" placeholder="Peso aproximado (Kgs)" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Estatura" :rules="{ required: true, min_value: 1, max_value: 3 }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Estatura:" label-for="h-input-estatura">
                      <b-form-input type="number" step="0.01" id="h-input-estatura" v-model="caracterizacion.estatura" placeholder="Estatura aproximada (Mts)" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Te encuentras en estado de embarazo?" :rules="{ required: true }" v-slot="validationContext" v-if="caracterizacion.genero === 'FEMENINO'">
                    <b-form-group label-cols-md="4" label="¿Te encuentras en estado de embarazo?" label-for="select-embarazo">
                      <b-form-radio-group id="h-select-embarazo" v-model="caracterizacion.embarazo" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Has sido diagnosticado(a) Covid-19 positivo?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Has sido diagnosticado(a) Covid-19 positivo?" label-for="h-select-covid">
                      <b-form-radio-group id="h-select-covid" v-model="caracterizacion.covid" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>

                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Has sido diagnosticado con alguna de estas enfermedades?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Has sido diagnosticado con alguna de estas enfermedades?" label-for="h-select-enfermedades-alto-riesgo">
                      <!--
                      <b-form-checkbox-group id="h-select-enfermedades-alto-riesgo" v-model="caracterizacion.enfermedadAltoRiesgo" stacked>
                        <b-form-checkbox v-for="entry in enfermedades" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      -->
                      <b-form-radio-group id="h-select-enfermedades-alto-riesgo" v-model="caracterizacion.enfermedadAltoRiesgo" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-text>
                        Diabetes, Hipertensión arterial, Insuficiencia Cardiaca, Infarto de miocardio, Cardiopatía Congénita, Hipertensión Pulmonar,
                        Accidente cerebrovascular (derrame o trombosis cerebral), Enfermedades autoinmunes como lupus o VIH/SIDA, Enfermedad Pulmonar obstructiva (EPOC),
                        Enfisema, Bronquitis crónica, Fibrosis pulmonar, Antracosis, Silicosis, Asma
                      </b-form-text>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Has tenido algún transplante de médula ósea o de otros órganos?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Has tenido algún transplante de médula ósea o de otros órganos?" label-for="h-select-transplante">
                      <b-form-radio-group id="h-select-transplante" v-model="caracterizacion.transplante" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Requieres tratamiento médico especial?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Requieres tratamiento médico especial?" label-for="h-select-tratamiento-medico">
                      <!--
                      <b-form-checkbox-group id="h-select-tratamiento-medico" v-model="caracterizacion.tratamientoMedico" stacked>
                        <b-form-checkbox v-for="entry in tratamientosMedicos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      -->
                      <b-form-radio-group id="h-select-tratamiento-medico" v-model="caracterizacion.tratamientoMedico" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-text>
                        Tratamiento con corticoides (por ejemplo, prednisona), Tratamiento por cáncer en los últimos 5 años,
                        Tratamiento médico por insuficiencia renal crónica, Tratamiento médico por cirrosis hepática o enfermedad hepática crónica
                      </b-form-text>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!--
                  <validation-provider name="Temperatura Corporal actual" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="Temperatura Corporal actual:" label-for="h-input-temperatura">
                      <b-form-input id="h-input-temperatura" v-model="caracterizacion.temperatura" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Presentas alguno de estos síntomas en las últimas 24 horas?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Presentas alguno de estos síntomas en las últimas 24 horas?" label-for="h-select-sintomas-diario">
                      <b-form-radio-group id="h-select-sintomas-diario" v-model="caracterizacion.sintomasDiarios" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-text>
                        Goteo o congestión nasal "no relacioanda con procesos
                        alérgicos", tos seca y persistente, dolor de Garganta,
                        Fiebre, dificultad para respirar, malestar general o
                        escalofrío que te limite las actividades de la vida
                        diaria, dolor muscular o en los huesos, Pérdida de
                        olfato y gusto.
                      </b-form-text>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  -->
                </b-card-body>
                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!-- Datos académicos previos -->
            <b-card no-body v-if="visibles.indexOf('datosAcademicosPrevios') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosAcademicosPrevios'))" block :disabled="!actives.includes('datosAcademicosPrevios')">Datos académicos previos</b-button>
              </b-card-header>
              <b-collapse id="datos-academicos-previos" accordion="accordion" role="tabpanel" :visible="visible === 'datosAcademicosPrevios'">
                <b-card-body v-if="visible === 'datosAcademicosPrevios'">
                  <validation-provider name="¿Repetiste durante el bachillerato alguno de los grados?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Repetiste durante el bachillerato alguno de los grados?" label-for="select-grados-repetidos">
                      <b-form-radio-group id="select-grados-repetidos" v-model="caracterizacion.gradosRepetidos" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuál es tu nivel académico actual?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuál es tu nivel académico actual?" label-for="select-nivel-academico">
                      <b-form-radio-group id="select-nivel-academico" v-model="caracterizacion.nivelAcademico" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in nivelesAcademicos" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>

                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos de orientacion profesional-->
            <b-card no-body v-if="visibles.indexOf('datosDeOrientacionProfesional') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosDeOrientacionProfesional'))" block :disabled="!actives.includes('datosDeOrientacionProfesional')">Datos de orientación profesional</b-button>
              </b-card-header>
              <b-collapse id="h-datos-orientacion-profesional" accordion="accordion" role="tabpanel" :visible="visible === 'datosDeOrientacionProfesional'" @show.once="loadDatosDeOrientacionProfesional">
                <b-card-body v-if="visible === 'datosDeOrientacionProfesional'">
                  <validation-provider name="¿Qué factores influyeron en la elección del programa que estudias actualmente?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Qué factores influyeron en la elección del programa que estudias actualmente?" label-for="h-select-factor-eleccion-carrera">
                      <b-form-checkbox-group id="h-select-factor-eleccion-carrera" v-model="caracterizacion.factorEleccionCarrera" :state="getValidationState(validationContext)" stacked>
                        <b-form-checkbox v-for="entry in factoresEleccionCarrera" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Fue este programa tu primera opción?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Fue este programa tu primera opción?" label-for="h-select-primerara-opcion">
                      <b-form-radio-group id="h-select-primerara-opcion" v-model="caracterizacion.primeraOpcion" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Por qué no estudiaste el programa o carrera que querías estudiar como primera opción?" :rules="{ required: true }" v-slot="validationContext" v-if="caracterizacion.primeraOpcion === 'NO'">
                    <b-form-group label-cols-md="4" label="¿Por qué no estudiaste el programa o carrera que querías estudiar como primera opción?" label-for="h-select-factor-segunda-eleccion">
                      <b-form-radio-group id="h-select-factor-segunda-eleccion" v-model="caracterizacion.factorSegundaEleccion" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in factoresSegundaEleccion" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Otra razón" :rules="{ required: true }" v-slot="validationContext" v-if="
                      caracterizacion.primeraOpcion === 'NO' &&
                        caracterizacion.factorSegundaEleccion === 'OTRO'">
                    <b-form-group label-cols-md="4" label="¿Cuál?" label-for="input-factor-segunda-eleccion-otro">
                      <b-form-input id="input-factor-segunda-eleccion-otro" v-model="caracterizacion.otroFactorSegundaEleccion" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>

                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Datos de ingreso a la universidad-->
            <b-card no-body v-if="visibles.indexOf('datosIngresoUniversidad') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('datosIngresoUniversidad'))" block :disabled="!actives.includes('datosIngresoUniversidad')">Datos de ingreso a la universidad</b-button>
              </b-card-header>
              <b-collapse id="h-datos-ingreso-universidad" accordion="accordion" role="tabpanel" :visible="visible === 'datosIngresoUniversidad'" @show.once="loadDatosIngresoUniversidad">
                <b-card-body v-if="visible === 'datosIngresoUniversidad'">
                  <validation-provider name="¿Al terminar el bachillerato, tu ingreso a la universidad fue?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Al terminar el bachillerato, tu ingreso a la universidad fue?" label-for="h-select-ingreso-universidad">
                      <b-form-radio-group id="h-select-ingreso-universidad" v-model="caracterizacion.ingresoUniversidad" :state="getValidationState(validationContext)" stacked>
                        <b-form-radio v-for="entry in ingresoUniversidad" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Indica las razones para no ingresar inmediatamente a la UTB" :rules="{ required: true }" v-slot="validationContext" v-if="
                      caracterizacion.ingresoUniversidad &&
                        caracterizacion.ingresoUniversidad !== 'INMEDIATO'">
                    <b-form-group label-cols-md="4" label="Indica las razones para no ingresar inmediatamente a la UTB:" label-for="h-select-razon-ingreso">
                      <b-form-checkbox-group id="h-select-razon-no-ingreso" v-model="caracterizacion.razonNoIngreso" :state="getValidationState(validationContext)" stacked>
                        <b-form-checkbox v-for="entry in razonesNoIngreso" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Otra razón" :rules="{ required: true }" v-slot="validationContext" v-if="
                      caracterizacion.razonNoIngreso.includes('OTRO') &&
                        caracterizacion.ingresoUniversidad !== 'INMEDIATO'">
                    <b-form-group label-cols-md="4" label="¿Cuál?" label-for="input-razon-no-ingreso-otro">
                      <b-form-input id="input-razon-no-ingreso-otro" v-model="caracterizacion.otraRazonNoIngreso" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="¿Cuáles son las principales razones para realizar tus estudios en la UTB?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Cuáles son las principales razones para realizar tus estudios en la UTB?" label-for="h-select-razon-ingreso">
                      <b-form-checkbox-group id="h-select-razon-ingreso" v-model="caracterizacion.razonIngreso" :state="getValidationState(validationContext)" stacked>
                        <b-form-checkbox v-for="entry in razonesIngreso" :key="entry.key" :value="entry.key">{{ entry.value }}</b-form-checkbox>
                      </b-form-checkbox-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider name="Otra razón" :rules="{ required: true }" v-slot="validationContext" v-if="
                      caracterizacion.razonIngreso.includes('OTRA')">
                    <b-form-group label-cols-md="4" label="¿Cuál?" label-for="input-razon-ingreso-otro">
                      <b-form-input id="input-razon-ingreso-otro" v-model="caracterizacion.otraRazonIngreso" :state="getValidationState(validationContext)"></b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>

                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Autorización comunicación-->
            <b-card no-body v-if="visibles.indexOf('autorizacion') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('autorizacion'))" block :disabled="!actives.includes('autorizacion')">Autorización de envío de información</b-button>
              </b-card-header>
              <b-collapse id="autorizacion" accordion="accordion" role="tabpanel" :visible="visible === 'autorizacion'">
                <b-card-body v-if="visible === 'autorizacion'">
                  <validation-provider name="¿Autorizas el envío de información de la UTB a través de mensajes de texto a tu celular?" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group label-cols-md="4" label="¿Autorizas el envío de información de la UTB a través de mensajes de texto a tu celular?" label-for="select-autorizacion">
                      <b-form-radio-group id="select-autorizacion" v-model="caracterizacion.autorizacion" :state="getValidationState(validationContext)">
                        <b-form-radio value="SI">Sí</b-form-radio>
                        <b-form-radio value="NO">No</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-card-body>

                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <!--Botones de confirmación-->
            <b-card no-body v-if="visibles.indexOf('confirmarEnvio') >= 0">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('confirmarEnvio'))" block :disabled="!actives.includes('confirmarEnvio')">Confirmar envío</b-button>
              </b-card-header>
              <b-collapse id="confirmar-envio" accordion="accordion" role="tabpanel" :visible="visible === 'confirmarEnvio'">
                <b-card-body v-if="visible === 'confirmarEnvio'">
                  <p>Haciendo clic en el botón enviar declara que todos los datos registrados antriormente se ajustan a la verdad.</p>
                </b-card-body>
                <b-card-footer>
                  <b-button type="submit" variant="success" class="ml-auto" style="display:block" :disabled="visible !== 'confirmarEnvio' || disabled">
                    Enviar
                    <b-icon icon="hand-thumbs-up"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
          </div>
        </b-form>
      </validation-observer>
      <div class="fixed-bottom">
        <b-container>
          <b-progress variant="success" max="100" height="2rem" striped>
            <b-progress-bar :value="progress" :label="`${progress.toFixed(0)}%`"></b-progress-bar>
          </b-progress>
        </b-container>
      </div>
    </b-container>
  </div>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios'
import { session, set } from 'store2'
import loadGoogleMapsApi from 'load-google-maps-api'
import { Vue, Component, Watch } from 'vue-property-decorator'

import { url } from '../../services/url_service'
import { redirect } from '../../services/redirect_service'

import settings from '../../settings'

@Component
export default class Caracterizacion extends Vue {
  //Data
  //tabs: Array<string> = []
  disabled: boolean = false
  actives: Array<string> = []
  visibles: Array<string> = []
  visible: string = null
  mapLoaded: boolean = false
  step: number = 0

  caracterizacion: any = {
    tipoIdentificacion: null,
    genero: null,
    estadoCivil: null,
    etnia: null,
    residencia: {
      barrio: null,
      ciudad: null,
      estado: null,
      pais: null,
      gps: null,
    },
    residenciaTemporal: {
      barrio: null,
      ciudad: null,
      estado: null,
      pais: null,
      gps: null,
    },
    accesoInternet: null,
    accesoComputador: null,
    situacionLaboral: null,
    dedicacionLaboral: null,
    situacionLaboralPadre: null,
    situacionLaboralMadre: null,
    situacionLaboralConyuge: null,
    medioTransporte: null,
    regimenSalud: null,
    eps: null,
    numeroDePersonasConviven: null,
    edadDeHijos: [],
    personasConvive: [],
    //tratamientoMedico: [],
    //enfermedadAltoRiesgo: [],
    vivienda: null,
    estrato: null,
    ingresoHogar: null,
    sisben: null,
    razonIngreso: [],
    razonNoIngreso: [],
    factorEleccionCarrera: [],
  }

  map: any = {
    /** Inicialmente las coordenadas de Cartagena */
    center: {
      lat: 10.39972,
      lng: -75.51444,
    },
    zoom: 10,
  }

  mapTemporal: any = {
    /** Inicialmente las coordenadas de Cartagena */
    center: {
      lat: 10.39972,
      lng: -75.51444,
    },
    zoom: 10,
  }

  foto: File = null
  certificadoAfiliacion: File = null

  generos: Array<any> = []
  estadosCiviles: Array<any> = []
  etnias: Array<any> = []
  discapacidades: Array<any> = []

  paises: Array<any> = [] //La tabla de paíces no cambia
  estados: Array<any> = []
  estadosTemporales: Array<any> = []
  ciudades: Array<any> = []
  ciudadesTemporales: Array<any> = []
  barrios: Array<any> = []
  barriosTemporales: Array<any> = []

  situacionesLaborales: Array<any> = []
  situacionesLaboralesMasculinas: Array<any> = []
  situacionesLaboralesFemeninas: Array<any> = []
  dedicacionesLaborales: Array<any> = []

  mediosTransportes: Array<any> = []

  regimenesSalud: Array<any> = []
  eps: Array<any> = []
  //tratamientosMedicos: Array<any> = []
  //enfermedades: Array<any> = []

  factoresEleccionCarrera: Array<any> = []
  factoresSegundaEleccion: Array<any> = []

  ingresoUniversidad: Array<any> = []
  razonesNoIngreso: Array<any> = []
  razonesIngreso: Array<any> = []

  posicionesEntreHermanos: Array<any> = []
  numeroPersonas: Array<any> = []
  edadesDeHijos: Array<any> = []

  nivelesAcademicos: Array<any> = []

  personasConvive: Array<any> = []
  edadesPersonasConvive: Array<any> = []
  estadosCivilesPadres: Array<any> = []
  viviendas: Array<any> = []
  estratos: Array<any> = []
  ingresosHogar: Array<any> = []
  nivelesSisben: Array<any> = []
  tiposIdentificacion: Array<any> = []
  accesoInternet: Array<any> = []
  accesoComputador: Array<any> = []

  //Computed
  get perteneceARegimen() {
    return ['CONTRIBUTIVO', 'SUBSIDIADO'].includes(
      this.caracterizacion.regimenSalud
    )
  }

  get casadoOUnionLibre() {
    return ['M', 'U'].includes(this.caracterizacion.estadoCivil)
  }

  get empleadoIndependiente() {
    return (
      ['EMPLEADO', 'INDEPENDIENTE'].indexOf(
        this.caracterizacion.situacionLaboral
      ) >= 0
    )
  }

  get convive() {
    return !['NINGUNO', undefined, null].includes(
      this.caracterizacion.numeroDePersonasConviven
    )
  }

  get tieneHermanos() {
    return !['NINGUNO', undefined, null].includes(
      this.caracterizacion.numeroDeHermanos
    )
  }

  get tieneHijos() {
    return !['NINGUNO', undefined, null].includes(
      this.caracterizacion.numeroDeHijos
    )
  }

  get progress() {
    return ((this.actives.length - 1) / (this.visibles.length - 1)) * 100
  }

  @Watch('caracterizacion.tieneResidenciaTemporal')
  public tieneResidenciaTemporalChange(value) {
    if (value === 'NO') {
      this.caracterizacion.residenciaTemporal = {
        barrio: null,
        ciudad: null,
        estado: null,
        pais: null,
        gps: null,
      }
    }
  }

  @Watch('caracterizacion.numeroDeHermanos')
  public numeroDeHermanosChange(value) {
    if (['NINGUNO', undefined, null].includes(value)) {
      this.caracterizacion.posicionEntreHermanos = null
      this.caracterizacion.hermanosConEstudios = null
    }
  }

  @Watch('caracterizacion.numeroDeHijos')
  public numeroDeHijosChange(value) {
    if (['NINGUNO', undefined, null].includes(value)) {
      this.caracterizacion.edadDeHijos = []
    }
  }

  @Watch('caracterizacion.situacionLaboral')
  public situacionLaboralChange(value) {
    if (!['EMPLEADO', 'INDEPENDIENTE'].includes(value)) {
      this.caracterizacion.dedicacionLaboral = null
      this.caracterizacion.salario = undefined
    }
  }

  @Watch('caracterizacion.estadoCivil')
  public estadoCivilSolteroChange(value) {
    if (!['M', 'U'].includes(value)) {
      this.caracterizacion.situacionLaboralConyuge = null
      this.caracterizacion.nivelAcademicoConyuge = undefined
    }
  }

  @Watch('caracterizacion.numeroDePersonasConviven')
  public conviveSinPersonasChange(value) {
    if (['NINGUNO', undefined, null].includes(value)) {
      this.caracterizacion.personasConvive = []
      //this.caracterizacion.edadesPersonasConvive = null
    }
  }

  @Watch('caracterizacion.regimenSalud')
  public sinRegimenSaludChange(value) {
    if (!['CONTRIBUTIVO', 'SUBSIDIADO'].includes(value)) {
      this.caracterizacion.eps = null
    }
  }

  @Watch('caracterizacion.genero')
  public generoChange(value) {
    if (value !== 'FEMENINO') {
      this.caracterizacion.embarazo = undefined
    }
  }

  @Watch('caracterizacion.primeraOpcion')
  public primeraOpcionChange(value) {
    if (value === 'SI') {
      this.caracterizacion.factorSegundaEleccion = undefined
      this.caracterizacion.otroFactorSegundaEleccion = undefined
    }
  }

  @Watch('caracterizacion.factorSegundaEleccion')
  public factorSegundaEleccionChange(value) {
    if (value !== 'OTRO') {
      this.caracterizacion.otroFactorSegundaEleccion = undefined
    }
  }

  @Watch('caracterizacion.ingresoUniversidad')
  public ingresoUniversidadInmediatoChange(value) {
    if (value === 'INMEDIATO') {
      this.caracterizacion.razonNoIngreso = []
      this.caracterizacion.otraRazonNoIngreso = undefined
    }
  }

  @Watch('caracterizacion.razonNoIngreso')
  public razonNoIngresoChange(value) {
    if (!value?.includes('OTRO')) {
      this.caracterizacion.otraRazonNoIngreso = undefined
    }
  }

  @Watch('caracterizacion.razonIngreso')
  public razonIngresoChange(value) {
    if (!value?.includes('OTRA')) {
      this.caracterizacion.otraRazonIngreso = undefined
    }
  }

  //Methods
  async abrirTab(step: number) {
    this.step = step
    this.visible = this.visibles[this.step]
    session.set(
      `caracterizacion_${this.$oauth.data.sub}`,
      this.caracterizacion,
      true
    )
  }

  async siguiente() {
    if (this.step < this.visibles.length - 1) {
      this.step++
      this.visible = this.visibles[this.step]
      if (!this.actives.includes(this.visible)) {
        this.actives.push(this.visible)
        session.set(
          `caracterizacion_actives_${this.$oauth.data.sub}`,
          this.actives,
          true
        )
      }
      session.set(
        `caracterizacion_${this.$oauth.data.sub}`,
        this.caracterizacion,
        true
      )
      this.scrollToTop()
    }
  }

  async subirFoto(foto: File) {
    let formData = new FormData()
    formData.append('UPLOAD', foto)
    await axios.post(url.create('/external/upload'), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  async subirCertificado(archivo) {
    let formData = new FormData()
    formData.append('UPLOAD', archivo)
    await axios.post(url.create('/external/upload'), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  async onRegimenSaludChange() {
    this.caracterizacion.eps = null
    this.eps = []
    this.eps = (
      await axios.get(url.create('/public/enums/eps'), {
        params: {
          regimen: this.caracterizacion.regimenSalud,
        },
      })
    )?.data
  }

  async onPaisChange() {
    this.caracterizacion.residencia.estado = null
    this.caracterizacion.residencia.ciudad = null
    this.estados = []
    this.ciudades = []
    this.barrios = []
    this.estados = (
      await axios.get(url.create('/public/lugares/estados'), {
        params: {
          pais: this.caracterizacion.residencia.pais,
        },
      })
    )?.data
  }

  async onDepartamentoChange() {
    this.caracterizacion.residencia.ciudad = null
    this.ciudades = []
    this.barrios = []
    this.ciudades = (
      await axios.get(url.create('/public/lugares/ciudades'), {
        params: {
          //pais: this.caracterizacion.residencia.pais,
          estado: this.caracterizacion.residencia.estado,
        },
      })
    )?.data
  }

  async onCiudadChange() {
    this.caracterizacion.residencia.barrio = null
    this.barrios = []
    this.barrios = (
      await axios.get(url.create('/public/lugares/barrios'), {
        params: {
          ciudad: this.caracterizacion.residencia.ciudad,
        },
      })
    )?.data
  }

  async onPaisAnteriorChange() {
    this.caracterizacion.residenciaTemporal.estado = null
    this.caracterizacion.residenciaTemporal.ciudad = null
    this.estadosTemporales = []
    this.ciudadesTemporales = []
    this.barriosTemporales = []
    this.estadosTemporales = (
      await axios.get(url.create('/public/lugares/estados'), {
        params: {
          pais: this.caracterizacion.residenciaTemporal.pais,
        },
      })
    )?.data
  }

  async onDepartamentoAnteriorChange() {
    this.caracterizacion.residenciaTemporal.ciudad = null
    this.ciudadesTemporales = []
    this.barriosTemporales = []
    this.ciudadesTemporales = (
      await axios.get(url.create('/public/lugares/ciudades'), {
        params: {
          //pais: this.caracterizacion.residenciaTemporal.pais,
          estado: this.caracterizacion.residenciaTemporal.estado,
        },
      })
    )?.data
  }

  async onCiudadAnteriorChange() {
    this.caracterizacion.residenciaTemporal.barrio = null
    this.barriosTemporales = []
    this.barriosTemporales = (
      await axios.get(url.create('/public/lugares/barrios'), {
        params: {
          ciudad: this.caracterizacion.residenciaTemporal.ciudad,
        },
      })
    )?.data
  }

  async geoLocalizar() {
    let client = await loadGoogleMapsApi({
      //key: 'AIzaSyCPOQy9j0sxxC1cLmc1YXSLLlcBvmZp_ZU',
      key: settings.gmapKey,
    })
    let geocoder = new client.Geocoder()
    //let client = new Client({})
    try {
      if (
        this.caracterizacion.residencia?.pais &&
        this.caracterizacion.residencia?.direccion
      ) {
        let direccion = `${this.caracterizacion.residencia?.direccion?.replaceAll(
          '/',
          ' '
        )},`
        direccion = direccion.substring(0, direccion.indexOf('|'))
        direccion += this.caracterizacion.residencia?.barrio
          ? `${this._filtroLugar(
            this.barrios,
            this.caracterizacion.residencia?.barrio
          )},`
          : ''
        direccion += this.caracterizacion.residencia?.ciudad
          ? `${this._filtroLugar(
            this.ciudades,
            this.caracterizacion.residencia?.ciudad
          )},`
          : ''
        direccion += this.caracterizacion.residencia?.estado
          ? `${this._filtroLugar(
            this.estados,
            this.caracterizacion.residencia?.estado
          )},`
          : ''
        direccion += this.caracterizacion.residencia?.pais
          ? `${this._filtroLugar(
            this.paises,
            this.caracterizacion.residencia?.pais
          )}`
          : ''
        let self = this
        geocoder.geocode(
          {
            address: direccion,
          },
          function (res) {
            let location = res[0]?.geometry?.location
            self.caracterizacion.residencia.gps = location
            let map: google.maps.Map = self.$refs.map['getMap']()
            map?.setCenter(location)
            map?.setZoom(16)
          }
        )
      }
    } catch (error) {
      //console.log(error)
    }
  }

  async geoLocalizarTemporal() {
    let client = await loadGoogleMapsApi({
      //key: 'AIzaSyCPOQy9j0sxxC1cLmc1YXSLLlcBvmZp_ZU',
      key: settings.gmapKey,
    })
    let geocoder = new client.Geocoder()
    //let client = new Client({})
    try {
      if (
        this.caracterizacion.residenciaTemporal?.pais &&
        this.caracterizacion.residenciaTemporal?.direccion
      ) {
        let direccion = `${this.caracterizacion.residenciaTemporal?.direccion?.replaceAll(
          '/',
          ' '
        )},`
        direccion = direccion.substring(0, direccion.indexOf('|'))
        direccion += this.caracterizacion.residenciaTemporal?.barrio
          ? `${this._filtroLugar(
            this.barriosTemporales,
            this.caracterizacion.residenciaTemporal?.barrio
          )},`
          : ''
        direccion += this.caracterizacion.residenciaTemporal?.ciudad
          ? `${this._filtroLugar(
            this.ciudadesTemporales,
            this.caracterizacion.residenciaTemporal?.ciudad
          )},`
          : ''
        direccion += this.caracterizacion.residenciaTemporal?.estado
          ? `${this._filtroLugar(
            this.estadosTemporales,
            this.caracterizacion.residenciaTemporal?.estado
          )},`
          : ''
        direccion += this.caracterizacion.residenciaTemporal?.pais
          ? `${this._filtroLugar(
            this.paises,
            this.caracterizacion.residenciaTemporal?.pais
          )}`
          : ''
        let self = this
        geocoder.geocode(
          {
            address: direccion,
          },
          function (res) {
            let location = res[0]?.geometry?.location
            self.caracterizacion.residenciaTemporal.gps = location
            let mapTemporal: google.maps.Map = self.$refs.mapTemporal[
              'getMap'
            ]()
            mapTemporal?.setCenter(location)
            mapTemporal?.setZoom(16)
          }
        )
      }
    } catch (error) {
      //console.log(error)
    }
  }

  _filtroLugar(donde: Array<object>, que: string): string {
    if (donde.length > 0) {
      return donde.filter(function (item) {
        return item['key'] === que
      })[0]['value']
    } else {
      return que
    }
  }

  async onMapChange(map) {
    this.caracterizacion.residencia.gps = map.getCenter()
  }

  async onMapAnteriorChange(map) {
    this.caracterizacion.residenciaTemporal.gps = map.getCenter()
  }

  getValidationState({ validated, dirty = null, valid = null, passed = null }) {
    return validated || valid ? valid : null
  }

  async logout() {
    let url = await this.$oauth.requestLogoutUrl()
    this.$oauth.logout()
    window.location.assign(url)
  }

  async onSubmit() {
    this.disabled = true
    this.caracterizacion.foto = this.foto?.name
    this.caracterizacion.certificadoAfiliacion = this.certificadoAfiliacion?.name
    try {
      let response = await axios.post(
        url.create('/external/caracterizaciones'),
        this.caracterizacion
      )
      this.onReset()
      session.clear()
      this.$router.push({ name: 'gracias' })
    } catch (e) {
      this.$bvToast.toast(
        'Los datos de tu encuesta no pudieron ser guardados, por favor contacte al administrador',
        {
          title: 'Ha ocurrido un error',
          variant: 'danger',
        }
      )
      this.disabled = false
    }
  }

  onReset() {
    this.$refs.observer['reset']()
    this.disabled = false
  }

  async loadDatosPersonales() {
    this.tiposIdentificacion = (
      await axios.get(url.create('/public/enums/tipos_identificacion'))
    )?.data
    this.generos = (await axios.get(url.create('/public/enums/generos')))?.data
    this.estadosCiviles = (
      await axios.get(url.create('/public/enums/estados_civiles'))
    )?.data
    this.etnias = (await axios.get(url.create('/public/enums/etnias')))?.data
    this.discapacidades = (
      await axios.get(url.create('/public/enums/discapacidades'))
    )?.data
  }

  async loadDatosMedicos() {
    this.regimenesSalud = (
      await axios.get(url.create('/public/enums/regimenes_salud'))
    )?.data
    if (this.caracterizacion.regimenSalud) {
      let self = this
      this.eps = (
        await axios.get(url.create('/public/enums/eps'), {
          params: {
            regimen: self.caracterizacion.regimenSalud,
          },
        })
      )?.data
    }
    // this.enfermedades = (
    //   await axios.get(url.create('/public/enums/enfermedades'))
    // )?.data
    // this.tratamientosMedicos = (
    //   await axios.get(url.create('/public/enums/tratamientos_medicos'))
    // )?.data
  }

  async loadDatosFamiliares() {
    this.edadesDeHijos = (
      await axios.get(url.create('/public/enums/edades_de_hijos'))
    )?.data
  }

  async loadDatosSocioeconomicos() {
    this.situacionesLaborales = (
      await axios.get(url.create('/public/enums/situaciones_laborales'))
    )?.data
    this.situacionesLaboralesMasculinas = (
      await axios.get(
        url.create('/public/enums/situaciones_laborales_masculinas')
      )
    )?.data
    this.situacionesLaboralesFemeninas = (
      await axios.get(
        url.create('/public/enums/situaciones_laborales_femeninas')
      )
    )?.data
    this.dedicacionesLaborales = (
      await axios.get(url.create('/public/enums/dedicaciones_laborales'))
    )?.data
    this.estadosCivilesPadres = (
      await axios.get(url.create('/public/enums/estados_civiles_padres'))
    )?.data
    this.edadesDeHijos = (
      await axios.get(url.create('/public/enums/edades_de_hijos'))
    )?.data
    this.personasConvive = (
      await axios.get(url.create('/public/enums/personas_convive'))
    )?.data
    this.viviendas = (
      await axios.get(url.create('/public/enums/viviendas'))
    )?.data
    this.estratos = (
      await axios.get(url.create('/public/enums/estratos'))
    )?.data
    this.ingresosHogar = (
      await axios.get(url.create('/public/enums/ingresos_hogar'))
    )?.data
    this.nivelesSisben = (
      await axios.get(url.create('/public/enums/niveles_sisben'))
    )?.data
    this.edadesPersonasConvive = (
      await axios.get(url.create('/public/enums/edades_personas_convive'))
    )?.data
  }

  async loadDatosAccesoTecnologico() {
    this.accesoInternet = (
      await axios.get(url.create('/public/enums/acceso_internet'))
    )?.data
    this.accesoComputador = (
      await axios.get(url.create('/public/enums/acceso_computador'))
    )?.data
  }

  async loadDatosDeContacto() {
    this.paises = (await axios.get(url.create('/public/lugares/paises')))?.data
    if (this.caracterizacion.residencia.pais) {
      this.estados = (
        await axios.get(url.create('/public/lugares/estados'), {
          params: {
            pais: this.caracterizacion.residencia.pais,
          },
        })
      )?.data
    }
    if (this.caracterizacion.residencia.estado) {
      this.ciudades = (
        await axios.get(url.create('/public/lugares/ciudades'), {
          params: {
            estado: this.caracterizacion.residencia.estado,
          },
        })
      )?.data
    }
    if (this.caracterizacion.residencia.ciudad) {
      this.barrios = (
        await axios.get(url.create('/public/lugares/barrios'), {
          params: {
            ciudad: this.caracterizacion.residencia.ciudad,
          },
        })
      )?.data
    }

    if (this.caracterizacion.residenciaTemporal.pais) {
      this.estadosTemporales = (
        await axios.get(url.create('/public/lugares/estados'), {
          params: {
            pais: this.caracterizacion.residenciaTemporal.pais,
          },
        })
      )?.data
    }
    if (this.caracterizacion.residenciaTemporal.estado) {
      this.ciudadesTemporales = (
        await axios.get(url.create('/public/lugares/ciudades'), {
          params: {
            estado: this.caracterizacion.residenciaTemporal.estado,
          },
        })
      )?.data
    }
    if (this.caracterizacion.residenciaTemporal.ciudad) {
      this.barriosTemporales = (
        await axios.get(url.create('/public/lugares/barrios'), {
          params: {
            ciudad: this.caracterizacion.residenciaTemporal.ciudad,
          },
        })
      )?.data
    }
  }

  async loadDatosDeOrientacionProfesional() {
    this.factoresEleccionCarrera = (
      await axios.get(url.create('/public/enums/factores_eleccion_carrera'))
    )?.data
    this.factoresSegundaEleccion = (
      await axios.get(url.create('/public/enums/factores_segunda_eleccion'))
    )?.data
  }

  async loadDatosIngresoUniversidad() {
    this.ingresoUniversidad = (
      await axios.get(url.create('/public/enums/ingreso_universidad'))
    )?.data
    this.razonesNoIngreso = (
      await axios.get(url.create('/public/enums/razones_no_ingreso'))
    )?.data
    this.razonesIngreso = (
      await axios.get(url.create('/public/enums/razones_ingreso'))
    )?.data
  }

  async load() {
    this.mediosTransportes = (
      await axios.get(url.create('/public/enums/medios_transportes'))
    )?.data
    this.posicionesEntreHermanos = (
      await axios.get(url.create('/public/enums/posiciones_entre_hermanos'))
    )?.data
    this.numeroPersonas = (
      await axios.get(url.create('/public/enums/numero_personas'))
    )?.data
    this.nivelesAcademicos = (
      await axios.get(url.create('/public/enums/niveles_academicos'))
    )?.data
  }

  scrollToTop() { }

  //Vue Lifecycle

  async loadBloques() {
    //let bloques = (await axios.get(url.create('/session/hide_blocks')))
    //  ?.data
    let bloques = [
      'proteccionDatos',
      'datosPersonales',
      'datosDeContacto',
      'datosFamiliares',
      'datosSocioeconomicos',
      'datosAccesoTecnologico',
      'datosDeMovilidad',
      'datosMedicos',
      'datosAcademicosPrevios',
      'datosDeOrientacionProfesional',
      'datosIngresoUniversidad',
      'autorizacion',
      'confirmarEnvio',
    ]
    if (bloques) {
      bloques = TABS.filter((x) => !bloques.includes(x))
      //Siempre visible
      //if (!bloques.includes('proteccionDatos')) {
      //  bloques.unshift('proteccionDatos')
      //}
      //Siempre visible
      //if (!bloques.includes('confirmarEnvio')) {
      //  bloques.push('confirmarEnvio')
      //}
      this.visibles = bloques
    } else {
      this.visibles = TABS
    }
  }

  async init() {
    await this.loadBloques()

    let caracterizacion = {}
    let actives = []
    let ultima = {}

    if (session.has(`caracterizacion_${this.$oauth.data.sub}`)) {
      caracterizacion = session.get(`caracterizacion_${this.$oauth.data.sub}`)
      if (session.has(`caracterizacion_actives_${this.$oauth.data.sub}`)) {
        actives = session.get(`caracterizacion_actives_${this.$oauth.data.sub}`)
      }
    } else {
      try {
        let response = await axios.get(
          url.create('/external/caracterizaciones/ultima')
        )
        caracterizacion = response.data?.data?.respuestas
        actives = this.visibles
        session.set(`caracterizacion_actives_${this.$oauth.data.sub}`, actives)
      } catch {
        //Do nothing when error
      }
      if (Object.keys(caracterizacion).length <= 0) {
        try {
          let response = await axios.get(
            url.create('/external/caracterizaciones/default')
          )
          caracterizacion = response.data
          actives = []
        } catch {
          //Do nothing when error
        }
      }
    }

    let temp = Object.assign({}, this.caracterizacion) //Copia los valores (evita apuntadores)
    this.caracterizacion = Object.assign(temp, ultima, caracterizacion)

    this.step = 0
    //this.actives.clear()
    this.visible = this.visibles[this.step]
    if (actives.length > 1) {
      this.actives = actives
    } else {
      this.actives = [this.visible]
    }
  }

  // Vue lifecycle
  created() {
    this.load()
  }

  mounted() {
    this.init()
  }
}

// Bloques por defecto (Deben estar en el mismo orden de la encuesta)
const TABS = [
  'proteccionDatos',
  'datosPersonales',
  'datosDeContacto',
  'datosFamiliares',
  'datosSocioeconomicos',
  'datosAccesoTecnologico',
  'datosDeMovilidad',
  'datosMedicos',
  'datosAcademicosPrevios',
  'datosDeOrientacionProfesional',
  'datosIngresoUniversidad',
  'autorizacion',
  'confirmarEnvio',
]
</script>

<style lang="scss">
.encuestas {
  & .custom-select option:not(:first-child),
  & .custom-select.is-valid {
    text-transform: uppercase;
  }
}
</style>
